<template>
  <div class="history">
    <div class="keyword-field">
      <van-field
        v-model="query.search"
        left-icon="search"
        placeholder="请输入搜索关键字"
        @click-left-icon="search"
      />
    </div>

    <div class="filters">
      <div class="row">
        <div class="time" @click="showTimer = !showTimer">
          <span>日期：</span>
          <span>{{ time }}</span>
          <img
            class="pull-icon"
            :class="{reverse: showTimer}"
            src="@/assets/image/pull.png"
          />
        </div>

        <div class="total d-flex">
          <div
            v-for="item in typeOptions"
            :key="item.value"
            :class="{
              active: selectedType === item.value,
              record: item.value === 0,
              reprint: item.value === 1
            }"
            @click="switchType(item)"
          >
            {{ item.name }}: {{ item.value === 0 ? totalRecord : totalReprintRecord }}
          </div>
        </div>
      </div>
      <div class="row" v-show="showTimer">
        <div
          class="time-selector"
          :class="{ active: selectedTime.value === time.value }"
          v-for="time in timeOptions"
          :key="time.value"
          @click="switchTime(time)"
        >
          {{ time.name }}
        </div>
      </div>
    </div>

    <div class="list">
      <div class="head">
        <div class="export"></div>
        <img src="@/assets/image/record/paper-1.png" class="paper-1">
        <img src="@/assets/image/record/paper-2.png" class="paper-2">
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="getList"
      >
        <template
          v-for="(item, index) in list"
        >
          <RecordItem
            :key="index"
            :item="item"
            @handleClick="goPage(item)"
          />
        </template>
      </van-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  getAllRecord,
  getPrintCount
} from '@/api/tag';
import { pageSize } from '@/config/index';
import RecordItem from '@/components/RecordItem';
export default {
  name: 'History',
  components: {
    RecordItem
  },
  computed: {
    ...mapGetters([ 'user' ]),
    time() {
      const { value, name } = this.selectedTime
      let time = ''
      switch (value) {
        case 1:
          time = this.$moment().format('yyyy/MM/DD')
          break;
        case 2:
          time = this.$moment().subtract(1, 'days').format('yyyy/MM/DD')
          break;
        case 3:
          time = name
          break;
        case 4:
          time = name
          break;
      }

      return time
    },
    isPrintAgain() {
      const {
        path
      } = this.$route

      return path.startsWith('/print-again')
    }
  },
  watch: {
    '$route.fullPath'() {
      this.init()
    }
  },
  data() {
    return {
      query: {
        search: '',
        page: 1,
        pageSize,
      },
      timeOptions: [
        {
          name: '今天',
          value: 1
        },
        {
          name: '昨天',
          value: 2
        },
        {
          name: '本周',
          value: 3
        },
        {
          name: '上周',
          value: 4
        }
      ],
      typeOptions: [
        {
          name: '常规打印总数',
          value: 0
        },
        {
          name: '补打总数',
          value: 1
        }
      ],
      selectedTime: {},
      selectedType: undefined,
      showTimer: false,
      totalRecord: 0,
      totalReprintRecord: 0,
      list: [],
      loading: false,
      finished: false,

    }
  },
  mounted(){
    this.pageEnterTime = new Date().getTime();
  },
  beforeDestroy(){
    var pageLeaveTime = new Date().getTime();
    var stayDuration = pageLeaveTime - this.pageEnterTime;
    window._hmt && _hmt.push(['_trackEvent', '打印历史页面停留时间', 'stay', '/record', JSON.stringify(this.user) +','+ stayDuration]);
  },
  methods: {
    getTimeRange() {
      // 根据时间范围获取时间段
      const {
        value
      } = this.selectedTime
      let start = undefined
      let end = undefined
      switch (value) {
        case 1:
          start = this.$moment().startOf('day').format('yyyy-MM-DD HH:mm:ss')
          end = this.$moment().endOf('day').format('yyyy-MM-DD HH:mm:ss')
          break;
        case 2:
          start = this.$moment().subtract(1, 'days').startOf('day').format('yyyy-MM-DD HH:mm:ss')
          end = this.$moment().subtract(1, 'days').endOf('day').format('yyyy-MM-DD HH:mm:ss')
          break;
        case 3:
          const week = this.$moment().week()
          start = this.$moment().week(week).startOf('week').format('yyyy-MM-DD HH:mm:ss')
          end = this.$moment().week(week).endOf('week').format('yyyy-MM-DD HH:mm:ss')
          break;
        case 4:
          const lastWeek = this.$moment().subtract(1, 'weeks')
          start = lastWeek.startOf('week').format('yyyy-MM-DD HH:mm:ss')
          end = lastWeek.endOf('week').format('yyyy-MM-DD HH:mm:ss')
          break;
      }

      return [start, end]
    },
    getList() {
      const {
        search,
        page,
        pageSize
      } = this.query
      const time = this.getTimeRange()

      const query = {
        search,
        print_start: time[0],
        print_end: time[1],
        is_add: this.selectedType,
        page,
        per_page: pageSize
      }
      if(search){
        window._hmt && _hmt.push(['_trackEvent', '打印历史页中的搜索', 'click', JSON.stringify(this.user) + ','+ search]);
      }

      getAllRecord(query)
      .then(res => {
        const {
          data,
          total
        } = res

        this.loading = false
        this.list = this.list.concat(data)
        this.finished = this.list.length >= total
        this.query.page += 1
      })
    },
    getPrintCount() {
      // 获取打印总数
      const time = this.getTimeRange()
      const query = {
        start: time[0],
        end: time[1]
      }

      getPrintCount(query)
      .then(res => {
        if (res) {
          const {
            total,
            add_number
          } = res

          this.totalRecord = total - add_number
          this.totalReprintRecord = add_number
        }
      })
    },
    switchTime(time) {
      this.selectedTime = time
      this.showTimer = false
      this.search()
      this.getPrintCount()
    },
    switchType(item) {
      const { value } = item
      this.selectedType = value
      this.search()
    },
    search() {
      this.query.page = 1
      this.list = []
      this.getList()
    },
    goPage(item) {
      const {
        tag_id,
        id,
        is_delete
      } = item
      if (is_delete == 1) {
        this.$Toast.fail('该标签模版已被禁用，无法打印！')

        return
      }

      const path = `/print/${tag_id}?t=${id}&${this.isPrintAgain ? 'm=1' : ''}`
      this.$router.push(path)
    },
    init() {
      this.selectedTime = this.timeOptions[0]
      this.getListByType()
      this.getPrintCount()
    },
    getListByType() {
      // 通过类型判断渲染数据方式
      const {
        path
      } = this.$route

      if (path.startsWith('/print-again')) {
        this.typeOptions.pop()
        this.switchType(this.typeOptions[0])
      } else if (path.startsWith('/record')) {
        this.switchTime(this.timeOptions[2])
      }
    },
  },
  created() {
    this.init()
    window._hmt && _hmt.push(['_trackEvent', '打印历史 按钮', 'click', JSON.stringify(this.user)]);
  }
}
</script>

<style lang="less" scoped>
  .history {
    .keyword-field {
      padding: 0 64px;
      margin: 22px 0 0;
      .van-field {
        background-color: rgba(255, 255, 255, 0.3);
        border-radius: 6px;
      }
      /deep/ .van-field__control {
        color: #fff;
        &::placeholder {
          color: rgba(255, 255, 255, 0.6);
        }
      }
      /deep/ .van-icon {
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .list {
      padding: 0 64px;
      margin: 30px 0 0;
      .head {
        height: 46px;
        position: sticky;
        top: 0;
        .export {
          width: 100%;
          height: 34px;
          background-color: #898989;
          border-radius: 17px;
          position: absolute;
          top: 0;
        }
        .paper-1, .paper-2 {
          position: absolute;
          width: 100%;
          top: 16px;
        }
        .paper-1 {
          height: 30px;
        }
        .paper-2 {
          height: 44px;
        }
      }
    }
    .filters {
      padding: 0 64px;
      .row {
        margin: 12px 0 0;
        display: flex;
        justify-content: space-between;
        .time {
          font-size: 42px;
          display: flex;
          align-items: center;
          color: #fff;
        }
        .time-selector {
          width: 240px;
          height: 100px;
          line-height: 100px;
          text-align: center;
          color: rgba(255, 255, 255, 0.6);
          border-radius: 6px;
          font-size: 48px;
          &.active {
            background-color: rgba(255, 255, 255, 0.3);
            color: #fff;
          }
        }
        .pull-icon {
          width: 44px;
          height: 44px;
          margin: 0 0 0 20px;
          transform: rotate(180deg);
          &.reverse {
            transform: rotate(0deg);
          }
        }
        .total {
          // gap: 14px;
          .flexgap(14px, row);
        }
        .record, .reprint {
          height: 64px;
          line-height: 64px;
          color: #fff;
          border-radius: 4px;
          font-size: 36px;
          padding: 0 20px;
        }
        .record {
          color: @primary-color-1;
          &.active {
            color: #fff;
            background-color: @primary-color-1;
          }
        }
        .reprint {
          color: @primary-color-2;
          &.active {
            color: #fff;
            background-color: @primary-color-2;
          }
        }
      }
    }
  }
</style>
